import * as React from "react";

const CenterDiv = ({ children }: { children: React.ReactNode }) => (
  <div className="columns is-centered">
    <div className="column is-narrow">{children}</div>
  </div>
);

export default CenterDiv;



// WEBPACK FOOTER //
// ./app/javascript/components/core/CenterDiv.tsx